import { FireWhiteIcon, GlutenFreeBlackIcon, MuscleIcon, SugarFreeWhiteIcon, VeganWhiteIcon } from "../../../assets/icons";
import { getStringFromProductTagType, ProductTagType } from "../../../models/base/ProductTagType";
import { TagStyleType } from "../../../models/base/TagStyleType"


interface TagTypesProps {
    style?: TagStyleType,
    primaryColor?: string;
    tags?: ProductTagType[];
}

const TagTypes: React.FC<TagTypesProps> = ({ style, primaryColor, tags }) => {

    if (style === TagStyleType.Basic_rounded) {
        return (
            <div className="client-product-tags-list-div" >

                {tags?.map(tag => {
                    return (
                        <div key={tag} className="small-box-div tag basic round" style={{ color: primaryColor, borderColor: primaryColor }}>
                            <div>{getStringFromProductTagType(tag)}</div>
                        </div>
                    )
                })}

            </div>
        )
    } else if (style === TagStyleType.Basic) {
        return (
            <div className="client-product-tags-list-div">

                {tags?.map(tag => {
                    return (
                        <div key={tag} className="small-box-div tag basic" style={{ color: primaryColor, borderColor: primaryColor }}>
                            <div>{getStringFromProductTagType(tag)}</div>
                        </div>
                    )
                })}

            </div>
        )
    } else if (style === TagStyleType.Colored) {
        return (
            <div className="client-product-tags-list-div">

                {tags?.map(tag => {

                    switch (tag) {
                        case ProductTagType.Protein:
                            return (
                                <div className="small-box-div turquoise-bg tag" >
                                    <img src={MuscleIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>Protein</div>
                                </div>
                            )
                        case ProductTagType.Vegan:
                            return (
                                <div className="small-box-div dark-green-bg tag">
                                    <img src={VeganWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>Vegan</div>
                                </div>
                            )
                        case ProductTagType.GlutenFree:
                            return (
                                <div className="small-box-div orange-bg tag">
                                    <img src={GlutenFreeBlackIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>Gluten free</div>
                                </div>
                            )
                        case ProductTagType.Spicy:
                            return (
                                <div className="small-box-div red-spicy tag">
                                    <img src={FireWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>Spicy</div>
                                </div>
                            )
                        case ProductTagType.SugarFree:
                            return (
                                <div className="small-box-div green-sugar-free tag">
                                    <img src={SugarFreeWhiteIcon} loading="lazy" alt="" className="icon-size-16" />
                                    <div>Sugar free</div>
                                </div>
                            )
                        default:
                            return null;
                    }
                })}

            </div>
        )
    } else {
        return (
            <div className="client-product-tags-list-div" >

                {tags?.map(tag => {
                    return (
                        <div key={tag} className="small-box-div tag basic round" style={{ color: primaryColor, borderColor: primaryColor }}>
                            <div>{tag}</div>
                        </div>
                    )
                })}

            </div>
        )
    }
}

export default TagTypes;